/**
 * Política de contraseña de ProMedic, lado front.
 *
 * Misma regla que `Profile.js` / `TechnicianProfile.js` y que el servidor
 * (`mcp-server/src/utils/passwordPolicy.js`, que es quien manda): mínimo 8
 * caracteres, una mayúscula, una minúscula y un número. Un PIN numérico NO la
 * cumple. Devuelve la lista de lo que falta (vacía = válida).
 */
export const PASSWORD_MIN_LENGTH = 8;

export const passwordPolicyErrors = (password) => {
  const pw = typeof password === 'string' ? password : '';
  const faltan = [];
  if (pw.length < PASSWORD_MIN_LENGTH) faltan.push(`Al menos ${PASSWORD_MIN_LENGTH} caracteres`);
  if (!/[A-Z]/.test(pw)) faltan.push('Una letra mayúscula');
  if (!/[a-z]/.test(pw)) faltan.push('Una letra minúscula');
  if (!/[0-9]/.test(pw)) faltan.push('Un número');
  return faltan;
};

export default passwordPolicyErrors;
